import PropTypes from 'prop-types';

const HouseIcon = ({ color = '#0D0D0D', className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M0.75 23.25V9.75672L12 0.952375L23.25 9.75672V23.25H0.75Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M16.25 23.25H7.75V16.9533C7.75 14.6431 9.65081 12.75 12 12.75C14.3492 12.75 16.25 14.6431 16.25 16.9533V23.25Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

HouseIcon.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
};

export default HouseIcon;
